interface IGPF_FORMULA {
  openingBalance: number;
  monthly: number;
  rate: number;
  withdraw: number;
  years: number;
}
export const GPF_FORMULA = ({
  openingBalance,
  monthly,
  rate,
  withdraw,
  years,
}: IGPF_FORMULA) => {
  const ob = Number(openingBalance);
  const mon = Number(monthly);
  const r = Number(rate);
  const y = Number(years);
  const w = Number(withdraw);
  if (
    ob < 0 ||
    ob > 1e10 ||
    mon < 0 ||
    mon > 5e6 ||
    w < 0 ||
    w > 1e6 ||
    w > ob ||
    y < 1 ||
    y > 60
  ) {
    const emptyRes = 0;
    return {
      totalBalance: emptyRes.toFixed(0),
      totalWithdraw: emptyRes.toFixed(0),
      balance: emptyRes.toFixed(0),
    };
  }
  let total = ob + mon * 12;
  for (let i = 0; i < y; ++i) {
    total = total * (r / 100) + total;
    if (i === y - 1) break;
    total = total + mon * 12;
  }
  const res = Math.round(total - w);
  return {
    totalBalance: total.toFixed(0),
    totalWithdraw: w.toFixed(0),
    balance: res.toFixed(0),
  };
};
